import React, { useCallback, useEffect, useState } from 'react';
import './accept.css'; // Add custom styles here
import { Button, Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import { useDropzone } from "react-dropzone";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { API_URL } from 'http/url.helper';
import Select from 'react-dropdown-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { callBankList } from 'http/fundLync/common.helper';
import { getOneDeal } from 'http/fundLync/deal.helper';

const AcceptSteps = () => {
  const [selectedOption, setSelectedOption] = useState('');
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [bankList, setBankList] = useState([]);
  const [dealDetails, setDealDetails] = useState([]);
  const [showModal, setShowModal] = useState(false); // For modal popup
  const [loading, setLoading] = useState(false); // For loader
  const [uiUpdated, setUiUpdated] = useState(false)
  const urlParams = new URLSearchParams(window.location.search);
  const encodedDealId = urlParams.get("dealId");
  const dealId = atob(encodedDealId);
  const amount = urlParams.get("amount");
  const rate = urlParams.get("rate");
  const tenure = urlParams.get("tenure");
  const applicationId = urlParams.get("applicationId");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleProceedToSign = () => {
    setShowModal(true); // Open modal when the button is clicked
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close modal
    setLoading(true); // Show loading spinner after closing modal

    // Simulate processing time (3-5 seconds)
    setTimeout(() => {
      setLoading(false); // Stop spinner
      setUiUpdated(true); // Update UI
    }, 3000);
  };
  const validationFileUpload = useFormik({
    enableReinitialize: true,
    initialValues: {
      fileUpload: [],
      fileUpload1: [],
      fileUpload2: [],
      // deal_id: '',
    },
    validationSchema: Yup.object({
      fileUpload: Yup.array()
        .min(1, "At least one file is required")
        .required("Files are required"),

      fileUpload1: Yup.array()
        .min(1, "At least one file is required")
        .required("Files are required"),

      fileUpload2: Yup.array()
        .min(1, "At least one file is required")
        .required("Files are required"),
    }),
    onSubmit: (values) => {
      handleFileUpload(values);
      const delay = 3000;
      setTimeout(() => {
        callDocDetailsAfterSave();
      }, delay);
    },
  });

  const handleFileUpload = async (values) => {
    setErrorMessage(null)
    setLoading(true);
    try {
      const user = decryptedValue(localStorage.getItem("user"));
      const userid = user.id;
      if (values.fileUpload) {
        const uploadedUrls = await uploadFile(values.fileUpload);
      } else if (values.fileUpload1) {
        const uploadedUrls = await uploadFile(values.fileUpload1);
      } else {
        const uploadedUrls = await uploadFile(values.fileUpload2);
      }

      let response;


      setToastInfo({
        message: "Files Uploaded Successfully",
        showToast: true,
        role: "success",
      });
      validationFileUpload.resetForm();
      setAdditionalDocSelectedGroup(null);
      setDeal(null);
      setUploadProgress({});
      setErrorMessage(null);
      callDocDetailsAfterSave();

    } catch (error) {
      setErrorMessage(error.message);
      setToastInfo({
        message: error.message,
        showToast: true,
        role: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const uploadFile = async (files) => {
    const uploadPromises = files.map(
      (file) =>
        new Promise((resolve, reject) => {
          if (file) {
            setUploadProgress((prev) => ({ ...prev, [file.name]: 0 }));
            let formData = new FormData();
            formData.append("upl", file);
            const config = {
              onUploadProgress: (progressEvent) => {
                const percentage = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );

                setUploadProgress((prev) => ({
                  ...prev,
                  [file.name]: percentage,
                }));
              },
            };
            axios
              .post(`${API_URL}/s3/uploadSystemConfigFiles`, formData, config)
              .then((response) => {
                if (response.status === 200) {
                  resolve(response.data[0].fileName);
                } else {
                  reject(response.data.message);
                }
                callDocDetailsAfterSave()
              })
              .catch((error) => {
                reject(error.response?.data?.message || error.message);
              });
          } else {
            reject("File is undefined or null");
          }
        })
    );

    try {
      const uploadedUrls = await Promise.all(uploadPromises);
      return uploadedUrls;
    } catch (error) {
      throw new Error(error);
    }
  };
  const handleDrop = useCallback(
    (acceptedFiles, fieldName) => {
      if (acceptedFiles.length > 0) {
        validationFileUpload.setFieldValue(fieldName, [
          ...validationFileUpload.values[fieldName],
          ...acceptedFiles,
        ]);
      }
    },
    [validationFileUpload]
  );
  const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } =
    useDropzone({ onDrop: (files) => handleDrop(files, "fileUpload") });

  const { getRootProps: getRootProps1, getInputProps: getInputProps1, isDragActive: isDragActive1 } =
    useDropzone({ onDrop: (files) => handleDrop(files, "fileUpload1") });

  const { getRootProps: getRootProps2, getInputProps: getInputProps2, isDragActive: isDragActive2 } =
    useDropzone({ onDrop: (files) => handleDrop(files, "fileUpload2") });

  useEffect(() => {
    getOneDeal({ id: dealId })
      .then((response) => {
        if (response) {
          setDealDetails(response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [])

  const options = [
    { value: 'pan', label: 'PAN Card' },
    { value: 'passport', label: 'Passport' },
    { value: 'voter', label: 'Voter ID' }
  ];

  const options2 = [
    { value: "Voter ID", label: "Voter ID (Electoral Photo Identity Card)" },
    { value: "Driving License", label: "Driving License" },
    { value: "Passport", label: "Passport" },
    { value: "Electricity Bill", label: "Electricity Bill (not older than 3 months)" },
    { value: "Water Bill", label: "Water Bill (not older than 3 months)" },
    { value: "Telephone Landline Bill", label: "Telephone Landline Bill (not older than 3 months)" },
    { value: "Ration Card", label: "Ration Card" },
    { value: "Gas Connection Bill", label: "Gas Connection Bill (not older than 3 months)" },
    { value: "Rent Agreement", label: "Rent Agreement (registered)" },
    { value: "Government Employee ID", label: "Government Employee ID with Address" },
    { value: "Letter from NPR", label: "Letter Issued by National Population Register" },
  ];
  const options3 = [
    { value: 'account Statement', label: 'Account Statement' },
    { value: 'Cancelled Cheque', label: 'Cancelled Cheque' },
    { value: 'Passbook', label: 'Passbook' }
  ];
  function downloadFile(base64String, ext, fileName) {
    let source = "";
    if (ext == "zip") {
      source = `data:application/zip;base64,${base64String}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = fileName;
      link.click();
    } else {
      source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
      const link = document.createElement("a");
      link.href = source;
      link.download = fileName;
      link.click();
    }
  }
  function formatFunction(file, showToastCallback) {
    const str = file.substring(file.indexOf("com") + 4);
    const filename = file.substring(file.lastIndexOf("/") + 1);
    const ext = str.split(".").pop();
    const obj = {
      fileName: str,
    };

    downloadSystemConfigFile(obj)
      .then((response) => {
        if (response.code === 200) {
          downloadFile(response.result, ext, filename);
          showToastCallback({
            message: "Downloaded successfully",
            showToast: true,
            role: "success",
          });
        } else {
          showToastCallback({
            message: response.message,
            showToast: true,
            role: "error",
          });

        }
      })
      .catch((error) => { });
  }
  const handleToast = (info) => {
    setToastInfo(info);
  };
  useEffect(() => {
    loadBankList();
  }, []);
  const loadBankList = (search) => {
    // setIsBankLoading(true);
    callBankList({ page: 1, limit: 100, searchKey: search })
      .then((response) => {
        setBankList(response.data?.data || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const formatNumberWithCommas = (number) => {
    if (!dealDetails || dealDetails.length === 0) {
      return <div>Loading...</div>;
    }
    const formattedNumber = number?.toString().replace(/\./, ',');
    const parts = formattedNumber?.split(',');
    if (parts[0].length > 3) {
      const lastThree = parts[0].substr(parts[0].length - 3);
      const remaining = parts[0].slice(0, parts[0].length - 3);
      parts[0] = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
    }

    return parts.join(',');
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {!uiUpdated && <Breadcrumbs title="post-sanction documents" />}
          <div className="vertical-scroll">
            <Card style={{ border: uiUpdated ? "none" : "1px solid #ddd" }}>
              <CardBody>
                {!uiUpdated ? (
                  <>
                    <h5 className="text-success d-block entityDetailsValue mb-2 mt-2 fw-bold">
                      Step 1
                    </h5>
                    <div className='mb-4'>
                      <label>
                        <Input
                          type="radio"
                          value="manual"
                          checked={selectedOption === 'manual'}
                          onChange={handleOptionChange}
                          style={{ marginRight: '10px' }}
                        />
                        Upload Document Manually
                      </label>
                      <label style={{ marginLeft: '20px' }}>
                        <Input
                          type="radio"
                          value="digilocker"
                          checked={selectedOption === 'digilocker'}
                          onChange={handleOptionChange}
                          style={{ marginRight: '10px' }}
                        />
                        Fetch from Digilocker
                      </label>
                    </div>

                    {selectedOption === 'manual' && (
                      <div>
                        <div>
                          <Row>
                            <Col sm="12" md="4" className='mb-3'>
                              <div>
                                <label htmlFor="idProof" className="required-sign form-label">
                                  Upload ID Proof*
                                </label>
                                <Select
                                  id="idProof"
                                  options={options}
                                  placeholder="Select an ID proof"
                                  className="custom-select-dropdown"
                                />
                              </div>
                            </Col>
                            <Col sm="12" md="4" style={{ marginTop: "22px" }}>
                              <div
                                style={{
                                  display: "table",
                                  width: "100%",
                                  backgroundColor: "#fff",
                                  border: "dashed 1px #21aa47",
                                  borderRadius: "5px",
                                  marginBottom: "10px",
                                }}
                                // className="drop"
                                onClick={() =>
                                  validationFileUpload.setFieldTouched(
                                    "fileUpload",
                                    true,
                                    setErrorMessage(null),
                                    setUploadProgress({})
                                  )
                                }
                              >
                                <div {...getRootProps()} className="text-wrapper" >


                                  <div className="centered" style={{
                                    fontSize: "14px",
                                    cursor: "pointer"
                                  }}>
                                    <input
                                      type="file"
                                      accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
                                      {...getInputProps({
                                        onClick: (event) => {
                                          setErrorMessage(null);
                                          setUploadProgress({});
                                        },
                                      })}
                                      style={{ display: "none" }}
                                    />
                                    <img
                                      src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                                      alt="Upload"
                                      className="img-fluid"
                                      style={{ width: "30px", marginBottom: "5px" }}
                                    />
                                    {isDragActive &&
                                      <p className="textLink">Drop here</p>
                                    }
                                    <span className="textLink" style={{ padding: "5px" }}>
                                      Browse files to attach
                                    </span>{" "}
                                    or Drop
                                    {/* </label> */}
                                  </div>
                                </div>
                              </div>
                              {validationFileUpload.values.fileUpload.length > 0 && (
                                <ul className="mt-2">
                                  {validationFileUpload.values.fileUpload.map(
                                    (file, index) => (
                                      <li key={index}>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <span style={{ fontSize: "10px" }}>{file.name}</span>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            style={{ border: "none", borderRadius: "50%", fontWeight: "800" }}
                                            onClick={() => {
                                              const updatedFiles = validationFileUpload.values.fileUpload.filter(
                                                (_, fileIndex) => fileIndex !== index
                                              );
                                              validationFileUpload.setFieldValue("fileUpload", updatedFiles);
                                            }}
                                          >
                                            X
                                          </button>
                                        </div>

                                        {uploadProgress[file.name] > 0 &&
                                          !errorMessage && (
                                            <div className="progress mt-2">
                                              <div
                                                className="progress-bar bg-success"
                                                role="progressbar"
                                                style={{
                                                  width: `${uploadProgress[file.name]
                                                    }%`,
                                                }}
                                                aria-valuenow="0"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              >
                                                {`${uploadProgress[file.name]}%`}
                                              </div>
                                            </div>
                                          )}
                                        {errorMessage && (
                                          <div className="alert alert-danger mt-2">
                                            {errorMessage}
                                          </div>
                                        )}
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="12" md="4">
                              <div>
                                <label htmlFor="AddressProof" className="required-sign form-label">
                                  Upload Address Proof*
                                </label>
                                <Select
                                  id="AddressProof"
                                  options={options2}
                                  placeholder="Select an Address Proof"
                                  className="custom-select-dropdown"
                                />
                              </div>
                            </Col>
                            <Col sm="12" md="4" style={{ marginTop: "22px" }}>
                              <div
                                style={{
                                  display: "table",
                                  width: "100%",
                                  backgroundColor: "#fff",
                                  border: "dashed 1px #21aa47",
                                  borderRadius: "5px",
                                  marginBottom: "20px",
                                }}
                                // className="drop"
                                onClick={() =>
                                  validationFileUpload.setFieldTouched(
                                    "fileUpload1",
                                    true,
                                    setErrorMessage(null),
                                    setUploadProgress({})
                                  )
                                }
                              >
                                <div {...getRootProps1()} className="text-wrapper" >


                                  <div className="centered" style={{
                                    fontSize: "14px",
                                    cursor: "pointer"
                                  }}>
                                    <input
                                      type="file"
                                      accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
                                      {...getInputProps1({
                                        onClick: (event) => {
                                          setErrorMessage(null);
                                          setUploadProgress({});
                                        },
                                      })}
                                      style={{ display: "none" }}
                                    />
                                    <img
                                      src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                                      alt="Upload"
                                      className="img-fluid"
                                      style={{ width: "30px", marginBottom: "5px" }}
                                    />
                                    {isDragActive1 && <p className="textLink">Drop here</p>}
                                    <span className="textLink" style={{ padding: "5px" }}>
                                      Browse files to attach
                                    </span>{" "}
                                    or Drop
                                  </div>
                                </div>
                              </div>
                              {validationFileUpload.values.fileUpload1.length > 0 && (
                                <ul className="mt-2">
                                  {validationFileUpload.values.fileUpload1.map(
                                    (file, index) => (
                                      <li key={index}>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <span style={{ fontSize: "10px" }}>{file.name}</span>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            style={{ border: "none", borderRadius: "50%", fontWeight: "800" }}
                                            onClick={() => {
                                              const updatedFiles = validationFileUpload.values.fileUpload1.filter(
                                                (_, fileIndex) => fileIndex !== index
                                              );
                                              validationFileUpload.setFieldValue("fileUpload1", updatedFiles);
                                            }}
                                          >
                                            X
                                          </button>
                                        </div>

                                        {uploadProgress[file.name] > 0 &&
                                          !errorMessage && (
                                            <div className="progress mt-2">
                                              <div
                                                className="progress-bar bg-success"
                                                role="progressbar"
                                                style={{
                                                  width: `${uploadProgress[file.name]
                                                    }%`,
                                                }}
                                                aria-valuenow="0"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              >
                                                {`${uploadProgress[file.name]}%`}
                                              </div>
                                            </div>
                                          )}
                                        {errorMessage && (
                                          <div className="alert alert-danger mt-2">
                                            {errorMessage}
                                          </div>
                                        )}
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                            </Col>
                          </Row>
                        </div>

                        <h5 className="text-success d-block entityDetailsValue mb-2 mt-2 fw-bold">
                          Bank Details
                        </h5>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                          <Row>
                            <Col sm="12" md="4" className='mb-3'>
                              <div>
                                <label htmlFor="bankName" className="required-sign form-label">
                                  Bank Name*
                                </label>
                                <Select
                                  id="bankName"
                                  options={bankList.map((o) => {
                                    return { label: o.bankName, value: o.bankId };
                                  })}
                                  placeholder="Select Bank"
                                  className="custom-select-dropdown"
                                />

                              </div>
                            </Col>
                            <Col sm="12" md="4" className='mb-3'>
                              <div>
                                <label htmlFor="branchName" className="required-sign form-label">
                                  Branch Name*
                                </label>

                                <Input
                                  type="text"
                                  id="bankName"
                                  options={options2}
                                  placeholder="Select Banh Name"
                                  className="custom-select-dropdown"
                                />
                              </div>
                            </Col>
                            <Col sm="12" md="4" className='mb-3'>
                              <div>
                                <label htmlFor="accountNo" className="required-sign form-label">
                                  Account Number*
                                </label>
                                <Input
                                  type='text'
                                  id="accountNo"
                                  options={options2}
                                  placeholder="Enter an Account Number"
                                  className="custom-select-dropdown"
                                />
                              </div>
                            </Col>
                            <Col sm="12" md="4" className='mb-3'>
                              <div>
                                <label htmlFor="ifsc" className="required-sign form-label">
                                  IFSC code*
                                </label>
                                <Input
                                  type='text'
                                  id="ifsc"
                                  options={options2}
                                  placeholder="Enter an IFSC Code"
                                  className="custom-select-dropdown"
                                />
                              </div>
                            </Col>
                            <Col sm="12" md="4" className='mb-3'>
                              <div>
                                <label htmlFor="upload" className="required-sign form-label">
                                  Upload Document*
                                </label>
                                <Select
                                  id="upload"
                                  options={options3}
                                  placeholder="Select an option"
                                  className="custom-select-dropdown"
                                />
                              </div>
                            </Col>
                            <Col sm="12" md="4" className='mb-3' style={{ marginTop: "22px" }}>
                              <div
                                style={{
                                  display: "table",
                                  width: "100%",
                                  backgroundColor: "#fff",
                                  border: "dashed 1px #21aa47",
                                  borderRadius: "5px",
                                  marginBottom: "20px",
                                }}
                                onClick={() =>
                                  validationFileUpload.setFieldTouched(
                                    "fileUpload2",
                                    true,
                                    setErrorMessage(null),
                                    setUploadProgress({})
                                  )
                                }
                              >
                                <div {...getRootProps2()} className="text-wrapper" >


                                  <div className="centered" style={{
                                    fontSize: "14px",
                                    cursor: "pointer"
                                  }}>
                                    <input
                                      type="file"
                                      accept=".jpg, .png, .jpeg, .pdf, .xlsx, .xls"
                                      {...getInputProps2({
                                        onClick: (event) => {
                                          setErrorMessage(null);
                                          setUploadProgress({});
                                        },
                                      })}
                                      style={{ display: "none" }}
                                    />
                                    <img
                                      src="https://scfuat.cashinvoice.in/frontend/assets/themes/image/icon/cloud.png"
                                      alt="Upload"
                                      className="img-fluid"
                                      style={{ width: "30px", marginBottom: "5px" }}
                                    />
                                    {isDragActive2 && <p className="textLink">Drop here</p>}
                                    <span className="textLink" style={{ padding: "5px" }}>
                                      Browse files to attach
                                    </span>{" "}
                                    or Drop
                                  </div>
                                </div>
                              </div>
                              {validationFileUpload.values.fileUpload2.length > 0 && (
                                <ul className="mt-2">
                                  {validationFileUpload.values.fileUpload2.map(
                                    (file, index) => (
                                      <li key={index}>
                                        <div className="d-flex justify-content-between align-items-center">
                                          <span style={{ fontSize: "11px" }}>{file.name}</span>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            style={{ border: "none", borderRadius: "50%", fontWeight: "800" }}
                                            onClick={() => {
                                              const updatedFiles = validationFileUpload.values.fileUpload2.filter(
                                                (_, fileIndex) => fileIndex !== index
                                              );
                                              validationFileUpload.setFieldValue("fileUpload2", updatedFiles);
                                            }}
                                          >
                                            X
                                          </button>
                                        </div>

                                        {uploadProgress[file.name] > 0 &&
                                          !errorMessage && (
                                            <div className="progress mt-2">
                                              <div
                                                className="progress-bar bg-success"
                                                role="progressbar"
                                                style={{
                                                  width: `${uploadProgress[file.name]
                                                    }%`,
                                                }}
                                                aria-valuenow="0"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              >
                                                {`${uploadProgress[file.name]}%`}
                                              </div>
                                            </div>
                                          )}
                                        {errorMessage && (
                                          <div className="alert alert-danger mt-2">
                                            {errorMessage}
                                          </div>
                                        )}
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </div>
                    )}
                    {selectedOption === 'digilocker' && (
                      <div className='outerCongrats'
                      >
                        <div className="congratsBox">
                          <h4 style={{ color: "black" }}>Digilocker KYC</h4>
                          <p style={{ color: "#8b8584" }}>Please do Digilocker KYC</p>
                          <p
                            style={{
                              color: "#22aa48",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                          >
                            Fetch Document From Digilocker
                          </p>
                          <p style={{ fontSize: "12px", color: "#555" }}>
                            By proceeding further I hereby authorize Digio to pull my documents
                            from Digilocker and share with Digio.
                          </p>
                          <p style={{ fontSize: "12px", color: "#747474" }}>
                            <Input type="checkbox" style={{ marginRight: "10px" }} />
                            I provide my consent to share my Aadhaar Number, Date of Birth, and
                            Name from my Aadhaar eKYC information with the Income Tax Department,
                            Govt of India, All States for the purpose of fetching my PAN
                            Verification Record into DigiLocker.
                          </p>
                          <Button type="button" color="success" className="me-2 mt-2" style={{ width: "100%" }}>
                            Authenticate Aadhaar
                          </Button>
                        </div>
                      </div>
                    )}
                    <h5 className="text-success d-block entityDetailsValue mb-2 mt-2 fw-bold">
                      Step 2
                    </h5>
                    <Button
                      type="button"
                      color="success"
                      className="me-2 mt-2"
                      onClick={handleProceedToSign}
                    >
                      Proceed to Loan Agreement e-sign
                    </Button>
                  </>
                ) : (
                  <div>
                    <div className='outerCongrats'>
                      <div className='congratsBox'>
                        <h2 className='text-success'>🎉 Congratulations! 🎉</h2>
                        <p style={{ marginTop: "40px" }}>Loan Sanction ID:  <span className='text-success'>{applicationId ? applicationId : "Not Available"}</span></p>
                        <p>Your loan application of  <span className='text-dark' style={{ color: "#4f4c4d", fontWeight: "600" }}>{dealDetails?.loanRequirement ? `₹ ${formatNumberWithCommas(dealDetails?.loanRequirement)}` : ""}</span> has been sanctioned.</p>
                        <p className='text-success' style={{ marginTop: "20px" }}>Bank Details: </p>

                        <div className="row" style={{ marginBottom: "0" }}>
                          {/* Static Bank Details */}
                          <div className="col-6" style={{ textAlign: "right" }}>
                            <strong>Account Holder Name:</strong>
                          </div>
                          <div className="col-6" style={{ textAlign: "left" }}>
                            Rakesh Singh
                          </div>

                          <div className="col-6" style={{ textAlign: "right" }}>
                            <strong>Bank Name:</strong>
                          </div>
                          <div className="col-6" style={{ textAlign: "left" }}>
                            HDFC Bank
                          </div>

                          <div className="col-6" style={{ textAlign: "right" }}>
                            <strong>Branch Name:</strong>
                          </div>
                          <div className="col-6" style={{ textAlign: "left" }}>
                            Mumbai Branch
                          </div>

                          <div className="col-6" style={{ textAlign: "right" }}>
                            <strong>IFSC Code:</strong>
                          </div>
                          <div className="col-6" style={{ textAlign: "left" }}>
                            HDXXXXX1234
                          </div>
                        </div>

                        <div className="row" style={{ marginBottom: "0" }}>
                          {/* Dynamic Loan Details */}
                          <div className="col-6" style={{ textAlign: "right" }}>
                            <strong>Offered Amount:</strong>
                          </div>
                          <div className="col-6" style={{ textAlign: "left" }}>
                            ₹ {amount ? formatNumberWithCommas(amount) : "Not Available"}
                          </div>

                          <div className="col-6" style={{ textAlign: "right" }}>
                            <strong>Rate of Interest:</strong>
                          </div>
                          <div className="col-6" style={{ textAlign: "left" }}>
                            {rate ? `${rate}%` : "Not Available"}
                          </div>

                          <div className="col-6" style={{ textAlign: "right" }}>
                            <strong>Tenure:</strong>
                          </div>
                          <div className="col-6" style={{ textAlign: "left" }}>
                            {tenure ? `${tenure}` : "Not Available"}
                          </div>
                        </div>
                        <p style={{ marginTop: "20px" }}>
                          The sanctioned amount will be transferred shortly to the <span className='text-success fw-bold'>HDXXXX1234</span> account.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
      {loading && (
        <div className='spinnerstatic'
        >
          <Spinner animation="border" role="status" variant="light">
            <span >Loading...</span>
          </Spinner>
        </div>
      )}
      <Modal
        isOpen={showModal}
        role="<dialog>"
        autoFocus={true}
        centered
        data-toggle="modal"
        toggle={() => {
          // setShowModal(!showModal);
          handleCloseModal();
        }}
      >
        <ModalBody>
          <img
            src="https://credlyncuat.cashinvoice.in/static/media/digio.265ba0759692b1e25dcd.png"
            alt="Digio Modal"
            style={{ maxWidth: "100%", borderRadius: "10px" }}
          />
        </ModalBody>
      </Modal>
    </React.Fragment>

  );
};

export default AcceptSteps;
